import React from 'react';
import { GridPattern } from '../common/GridPattern';
import { CartesianAxes } from '../common/CartesianAxes';
import { DraggablePoint } from '../common/DraggablePoint';

export const PentagonInCircleComponent = ({ params, showCoords, onPointDrag, svgRef, viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const { centerX = 200, centerY = 150, radius = 80, pentagonRotation = 0, showRadialLines = true, showCenter = true, circleColor = "black", pentagonColor = "black", radialColor = "black", strokeWidth = 2 } = params;
  
  const pentagonPoints = [];
  for (let i = 0; i < 5; i++) {
    const angle = (pentagonRotation + i * 72) * Math.PI / 180;
    const x = centerX + radius * Math.cos(angle);
    const y = centerY + radius * Math.sin(angle);
    pentagonPoints.push({ x, y });
  }
  
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const viewBox = `0 0 ${scaledWidth} ${scaledHeight}`;
  const displayHeight = Math.max(200, Math.min(800, viewportHeight * viewportScale));
  
  return (
    <svg ref={svgRef} viewBox={viewBox} className="w-full border border-gray-300" style={{ height: `${displayHeight}px` }}>
      <GridPattern viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
      
      <circle 
        cx={centerX} 
        cy={centerY} 
        r={radius} 
        fill="none" 
        stroke={circleColor} 
        strokeWidth={strokeWidth}
      />
      
      <polygon 
        points={pentagonPoints.map(p => `${p.x},${p.y}`).join(' ')}
        fill="none" 
        stroke={pentagonColor} 
        strokeWidth={strokeWidth}
      />
      
      {showRadialLines && pentagonPoints.map((point, i) => (
        <line 
          key={`radial-${i}`}
          x1={centerX} y1={centerY} 
          x2={point.x} y2={point.y} 
          stroke={radialColor} 
          strokeWidth={strokeWidth}
        />
      ))}
      
      {showCenter && (
        <>
          <circle cx={centerX} cy={centerY} r="3" fill={circleColor}/>
          <text x={centerX + 10} y={centerY + 5} fontSize="14" fontWeight="bold">O</text>
        </>
      )}
      
      <text x={pentagonPoints[0].x - 5} y={pentagonPoints[0].y - 10} fontSize="16" fontWeight="bold">A</text>
      <text x={pentagonPoints[1].x - 20} y={pentagonPoints[1].y - 5} fontSize="16" fontWeight="bold">B</text>
      <text x={pentagonPoints[2].x - 15} y={pentagonPoints[2].y + 20} fontSize="16" fontWeight="bold">C</text>
      <text x={pentagonPoints[3].x + 10} y={pentagonPoints[3].y + 15} fontSize="16" fontWeight="bold">D</text>
      <text x={pentagonPoints[4].x + 10} y={pentagonPoints[4].y - 10} fontSize="16" fontWeight="bold">E</text>
      
      {showCoords && (
        <>
          <DraggablePoint 
            cx={centerX} cy={centerY} 
            label="Center" coords={`(${centerX},${centerY})`}
            onDrag={(x, y) => onPointDrag('centerX', x, 'centerY', y)}
            svgRef={svgRef}
          />
          {pentagonPoints.map((point, i) => (
            <DraggablePoint 
              key={`vertex-${i}`}
              cx={point.x} cy={point.y} 
              label={String.fromCharCode(65 + i)} 
              coords={`(${Math.round(point.x)},${Math.round(point.y)})`}
              onDrag={(x, y) => {
                const dx = x - centerX;
                const dy = y - centerY;
                const newRadius = Math.sqrt(dx * dx + dy * dy);
                onPointDrag('radius', Math.round(newRadius));
              }}
              svgRef={svgRef}
            />
          ))}
        </>
      )}
      
      <CartesianAxes viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
    </svg>
  );
};

